dmx.Component('group', { render: function(node) { this.$parse(); } });